<script>
import { Line } from "vue-chartjs"
import TransactionAPI from "../../api/trace/transaction"
export default {
	extends: Line,
	data() {
		return {
			sentTransactionData: [],
			receivedTransactionData: [],
		}
	},
	mounted() {
		this.getEachMonthData()
	},
	methods: {
		async getEachMonthData() {
			let stats = await TransactionAPI.getTransactionDashboard() //array with objects

			let receivedData = stats.map((data) => data.received)
			let sentData = stats.map((data) => data.sent)

			this.receivedTransactionData = receivedData
			this.sentTransactionData = sentData
			this.renderChart(
				{
					labels: [
						"Jan",
						"Feb",
						"Mar",
						"Apr",
						"May",
						"Jun",
						"Jul",
						"Aug",
						"Sep",
						"Oct",
						"Nov",
						"Dec",
					],
					datasets: [
						{
							label: "Sent Transactions",
							data: this.sentTransactionData,
							backgroundColor: "transparent",
							borderColor: "#3498DB",
							pointBackgroundColor: "#3498DB",
						},
						{
							label: "Received Transactions",
							data: this.receivedTransactionData,
							backgroundColor: "transparent",
							borderColor: "#E74C3C",
							pointBackgroundColor: "#E74C3C",
						},
					],
				},
				{
					responsive: true,
					maintainAspectRatio: false,
					title: {
						display: false,
					},
					scales: {
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
								},
							},
						],
					},
				}
			)
		},
	},
}
</script>